import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-h5" }, "Новая поставка", -1)
const _hoisted_2 = { class: "d-flex mt-5 justify-end" }

import { createCtx, handleError } from '../../../helpers'
import { ref, Ref, computed } from 'vue'
import {
  AddProductSupplyOpts,
  PRODUCT_CATEGORIES_INFO,
  PRODUCT_CATEGORIES_REPORTS_UNITS,
  ProductCategory,
  ProductPlansService,
  enumGetValues,
} from '@prodcard/core'
import { useVuelidate, ErrorObject } from '@vuelidate/core'
import { required, helpers, minValue } from '@vuelidate/validators'
import { vMaska } from 'maska'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewSupplyForm',
  props: {
    productPlansService: {}
  },
  emits: ['new-supply', 'cancel'],
  setup(__props: any, { emit: emits }) {

const props = __props;





const isLoading = ref(false)
const newSupplyOpts: Ref<AddProductSupplyOpts> = ref({
  dataEntryDate: new Date(),
  category: ProductCategory.BREAD,
  amount: 1,
})
const supplyDate = computed(
  () =>
    `${newSupplyOpts.value.dataEntryDate.toLocaleDateString()} ${newSupplyOpts.value.dataEntryDate.toLocaleTimeString()}`,
)
const categoryItems = enumGetValues(ProductCategory).map(cat => {
  return {
    title: `${PRODUCT_CATEGORIES_INFO[cat as ProductCategory].description} ${
      PRODUCT_CATEGORIES_REPORTS_UNITS[cat as ProductCategory] || ''
    }`,
    value: cat,
  }
})

const rules = {
  dataEntryDate: {
    required: helpers.withMessage('Дата не может быть пустой', required),
  },
  category: {
    required: helpers.withMessage('Продовольственная категория не может быть пустой', required),
  },
  amount: {
    required: helpers.withMessage('Количество не может быть пустым', required),
    minValue: helpers.withMessage('Значение не может быть меньше 0', minValue(0)),
  },
}
const validator = useVuelidate<AddProductSupplyOpts>(rules, newSupplyOpts)
// eslint-disable-next-line @typescript-eslint/naming-convention
const maskOpts = { mask: '9.##', tokens: { 9: { pattern: /[0-9]/, multiple: true } } }

const getErrorMessages = (errors: ErrorObject[]) => {
  return errors.map((e: ErrorObject) => e.$message).join()
}

const addSupply = async () => {
  const valid = await validator.value.$validate()
  if (!valid) {
    return
  }

  handleError(async () => {
    await props.productPlansService.add(createCtx(), newSupplyOpts.value)
    emits('new-supply')
  }, isLoading)
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    onSubmit: _withModifiers(addSupply, ["prevent"]),
    onKeyup: _withKeys(addSupply, ["enter"])
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_v_text_field, {
        modelValue: supplyDate.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((supplyDate).value = $event)),
        label: "Дата*",
        readonly: "",
        class: "mt-5",
        "error-messages": getErrorMessages(_unref(validator).dataEntryDate.$errors)
      }, null, 8, ["modelValue", "error-messages"]),
      _createVNode(_component_v_select, {
        label: "Продовольственная категория*",
        modelValue: newSupplyOpts.value.category,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newSupplyOpts.value.category) = $event)),
        items: _unref(categoryItems),
        class: "mt-5",
        "error-messages": getErrorMessages(_unref(validator).category.$errors)
      }, null, 8, ["modelValue", "items", "error-messages"]),
      _withDirectives(_createVNode(_component_v_text_field, {
        label: "Количество*",
        class: "mt-5",
        modelValue: newSupplyOpts.value.amount,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newSupplyOpts.value.amount) = $event)),
        modelModifiers: { number: true },
        maxlength: "15",
        "error-messages": getErrorMessages(_unref(validator).amount.$errors)
      }, null, 8, ["modelValue", "error-messages"]), [
        [_unref(vMaska), void 0, maskOpts]
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_btn, {
          onClick: addSupply,
          disabled: isLoading.value,
          loading: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("Сохранить")
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ]),
    _: 1
  }, 8, ["onSubmit", "onKeyup"]))
}
}

})